export default __webpack_public_path__ + "static/media/promote_your_listing.f7db21b7.svg";